import $http from "../utils/http";

const cmdb = {
  // DynamoDB分页
  pagingQueryDynamoDB(params) {
    return $http.post(`${global.API_URL}/sme/resourceAwsDynamodb/pagingQueryDynamoDB`, params);
  },
  // 导出DynamoDB
  exportDynamoDB(params) {
    return $http.post(`${global.API_URL}/sme/resourceAwsDynamodb/exportDynamoDB`, params, {
      responseType: 'arraybuffer',
      timeout: 1000 * 60 * 20
    });
  },
  // 更新
  updateResource(params) {
    return $http.post(`${global.API_URL}/sme/resourceManagement/updateResource`, params);
  },
  // ECR分页
  pagingQueryAWSEcr(params) {
    return $http.post(`${global.API_URL}/sme/resourceAwsEcr/pagingQueryAWSEcr`, params);
  },
  // 导出ECR
  exportAWSEcr(params) {
    return $http.post(`${global.API_URL}/sme/resourceAwsEcr/exportAWSEcr`, params, {
      responseType: 'arraybuffer',
      timeout: 1000 * 60 * 20
    });
  },
  // ECS分页
  pagingQueryAWSEcs(params) {
    return $http.post(`${global.API_URL}/sme/resourceAwsEcs/pagingQueryEcs`, params);
  },
  // 导出ECS
  exportAWSEcs(params) {
    return $http.post(`${global.API_URL}/sme/resourceAwsEcs/exportAwsEcs`, params, {
      responseType: 'arraybuffer',
      timeout: 1000 * 60 * 20
    });
  },
  // 分页查询ECS 服务
  pagingQueryEcsService(params) {
    return $http.post(`${global.API_URL}/sme/ecsService/pagingQueryEcsService`, params)
  },
  // 分页查询ECS 任务
  pagingQueryEcsTask(params) {
    return $http.post(`${global.API_URL}/sme/ecsTask/pagingQueryEcsTask`, params)
  },
  // 分页查询KMS
  pagingQueryAwsKms(params) {
    return $http.post(`${global.API_URL}/sme/resourceManagement/pagingQueryAwsKms`, params)
  },
  // 导出KMS
  exportAwsKms(params) {
    return $http.post(`${global.API_URL}/sme/resourceManagement/exportAwsKms`, params, {
      responseType: 'arraybuffer',
      timeout: 1000 * 60 * 20
    });
  },
  // 分页查询DMS无服务器复制列表
  pagingQueryAwsDmsServerlessReplication(params) {
    return $http.post(`${global.API_URL}/sme/resourceManagement/pagingQueryAwsDmsServerlessReplication`, params)
  },
  // 导出DMS无服务器复制
  exportAwsDmsServerlessReplication(params) {
    return $http.post(`${global.API_URL}/sme/resourceManagement/exportAwsDmsServerlessReplication`, params, {
      responseType: 'arraybuffer',
      timeout: 1000 * 60 * 20
    });
  },
  // 分页查询DMS实例复制列表
  pagingQueryAwsDmsInstanceReplication(params) {
    return $http.post(`${global.API_URL}/sme/resourceManagement/pagingQueryAwsDmsInstanceReplication`, params)
  },
  // 导出DMS实例复制
  exportAwsDmsInstanceReplication(params) {
    return $http.post(`${global.API_URL}/sme/resourceManagement/exportAwsDmsInstanceReplication`, params, {
      responseType: 'arraybuffer',
      timeout: 1000 * 60 * 20
    });
  }
}

export default cmdb;



// WEBPACK FOOTER //
// ./src/api/cmdb.js